import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const AboutUs = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center">
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
              About <span className="text-emerald-600">LOANYARD CAPITAL</span>
            </h2>
            <div className="max-w-3xl mx-auto">
              <p className="text-sm font-bold uppercase tracking-widest text-emerald-700 mb-4">Corporate Finance &amp; Capital Advisory</p>
              <p className="text-lg text-slate-700 leading-relaxed mb-8">
                LOANYARD CAPITAL is a corporate finance firm delivering debt, equity, capital syndication, structured finance and M&amp;A solutions for HNIs, promoters, family businesses and corporates.
              </p>
              <Link
                to="/about-us"
                className="inline-flex items-center gap-2 text-emerald-700 font-semibold hover:gap-3 transition-all"
                data-testid="about-learn-more-link"
              >
                Learn More About Us <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
